import { hasIn } from 'lodash';

export default {
  activeLoader: (state) => state.activeLoader,
  activeTournaments: (state) => state.activeTournaments,
  activeQuests: (state) => state.activeQuests,
  activePrize: (state) => state.activePrize,
  boostState: (state) => state.boostState,
  channel: (state) => state.config.channel,
  config: (state) => state.config,
  dailyTopWins: (state) => state.topWinsData.daily,
  errorDetails: (state) => state.errorDetails,
  feedData: (state) => state.feedData,
  finishedTournaments: (state) => state.finishedTournaments,
  formattedTournamentStatus: (state) => state.formattedTournamentStatus,
  isAchievements: (state) => state.navigation.currentModule.toLowerCase() === 'achievements',
  isBadgeVisible: (state) => state.config.visibleBadge,
  isOffline: (state) => state.isOffline,
  minWinAmount: (state) => state.settings?.feed?.minWinAmount,
  monthlyTopWins: (state) => state.topWinsData.monthly,
  navigation: (state) => state.navigation,
  newLevelAnimationActive: (state) => state.newLevelAnimationState === 'active',
  newLevelAnimationReady: (state) => state.newLevelAnimationState === 'ready',
  newLevelName: (state) => state.newLevelName,
  newPlayer: (state) => state.newPlayer && !state.otherPlayerId,
  otherPlayerId: (state) => state.otherPlayerId,
  playerId: (state) => state.config.playerId,
  playerLeaderboard: (state) => state.playerLeaderboard,
  profileData: (state) => (state.otherPlayerId ? state.otherPlayerProfileData : state.profileData),
  progressBarPercentage: (state) => state.progressBarPercentage,
  questsLastWinners: (state) => state.questsLastWinners,
  questRewards: (state) => state.questRewards,
  settings: (state) => state.settings,
  starsProgressBarPercentage: (state) => state.starsProgressBarPercentage,
  subscribedToTournaments: (state) => state.subscribedToTournaments,
  showPlayerProfile: (state) => hasIn(state.navigation, 'achievements') && state.navigation.achievements.show && !!state.config.playerId,
  tenantId: (state) => state.config.tenantId,
  theme: (state) => state.theme,
  topWinsData: (state) => state.topWinsData,
  tournamentDetails: (state) => state.tournamentDetails,
  tournamentLeaderboard: (state) => state.tournamentLeaderboard,
  tournamentLeaderboardSize: (state) => state.tournamentLeaderboardSize,
  tournamentRankingInterval: (state) => state.tournamentRankingInterval,
  translation: (state) => (key) => state.translations[key],
  translations: (state) => state.translations,
  visibleModules: (state) => state.visibleModules,
  weeklyTopWins: (state) => state.topWinsData.weekly,
  widget: (state) => state.config.widget,
};
